import UserInfo from '@/resources/user-info';
import RootStateCommit from '@/store/mixins/rootstate-commit';

const MODULE_NAME = 'user-info';
const DEFAULT_STATE = {
  error: null,
  userInfo: null
};

export default {
  namespaced: true,
  state: { ...DEFAULT_STATE },
  /* eslint no-param-reassign: ["error", { "props": false }] */
  mutations: {
    parseResponseData(state, response) {
      state.userInfo = response;
    }
  },
  actions: {
    fetchData({ commit, rootState }) {
      const action = UserInfo(rootState.auth.token).get();

      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      action.then(
        response => {
          commit('parseResponseData', response.data);
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        }
      );

      return action;
    }
  }
};
